import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { UserUsageStatsOutput } from '../model/user-usage-stats.output';

@Injectable({ providedIn: 'root' })
export class FetchUserUsageStatsApiQuery extends ApiQuery<
	UserUsageStatsOutput,
	void
> {
	client = 'messaging';
	document = gql`
		query FetchUserUsageStats {
			fetchUserUsageStats {
				messagesSent
				messagesSentMax
				messagesSentPeriod
			}
		}
	`;
	method = 'fetchUserUsageStats';
}
